import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import React from 'react';
import PropTypes from 'prop-types';
import CarouselSlider from '../CarouselSlider';
import Image from '../Image';
import css from './UgcGridCarousel.module.scss';
import cssIndex from './ProductSpotlightSimple.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var UgcGridCarousel = function UgcGridCarousel(_ref) {
  var fabric = _ref.fabric,
      ugcs = _ref.ugcs,
      ugcsTitle = _ref.ugcsTitle;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h2", {
      className: css.ugcTitle,
      children: ugcsTitle
    }), /*#__PURE__*/_jsxs("div", {
      className: css.ugcs,
      children: [/*#__PURE__*/_jsx("div", {
        className: cssIndex.isDesktop,
        children: /*#__PURE__*/_jsx("ul", {
          className: css.gridContainer,
          tabIndex: 0,
          children: ugcs.map(function (_ref2) {
            var image = _ref2.image,
                hoverText = _ref2.hoverText;
            return /*#__PURE__*/_jsxs("li", {
              className: css.ugc,
              tabIndex: -1,
              children: [/*#__PURE__*/_jsx(Image, _objectSpread({}, image)), /*#__PURE__*/_jsx("div", {
                className: css.ugcHover,
                children: /*#__PURE__*/_jsx("p", {
                  className: css.hoverText,
                  children: hoverText
                })
              })]
            }, image.src);
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: cc([css.carouselContainer]),
        children: /*#__PURE__*/_jsx(CarouselSlider, {
          items: ugcs,
          name: fabric
        })
      })]
    })]
  });
};

UgcGridCarousel.propTypes = {
  fabric: PropTypes.string.isRequired,
  ugcs: PropTypes.arrayOf(PropTypes.shape({
    hoverText: PropTypes.string.isRequired,
    image: PropTypes.shape({
      alt: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired
    }).isRequired
  })).isRequired,
  ugcsTitle: PropTypes.string.isRequired
};
export default UgcGridCarousel;